import React from "react";
import { useTranslation } from "react-i18next";
import calendarIcon from "../../../assets/icons/package/calendar.png";
import checkIcon from "../../../assets/icons/package/check.png";
import crossIcon from "../../../assets/icons/package/cross-small.png";
import infinityIcon from "../../../assets/icons/package/infinity.png";
import "./OfferCard.css";

const OfferCard = ({ id, gigabytes, duration, price, currency, selected = false, topUpAvailable, onToggle }) => {
  const { t } = useTranslation();
  const isUnlimited = gigabytes === -1;

  const gbClassName = "offer-card-gb" + (isUnlimited ? " offer-card-gb--unlimited" : "");
  const cardClassName = "offer-card" + (selected ? " offer-card--selected" : "");

  return (
    <div className="offer-card-hover-wrapper">
      <div className={cardClassName} onClick={onToggle}>
        <div className="offer-card-header">
          <div className="offer-card-gb-wrapper">
            {isUnlimited && <img src={infinityIcon} alt="" className="offer-card-gb-icon" />}
            <span className={gbClassName}>{isUnlimited ? t("common.unlimited") : `${gigabytes} GB`}</span>
          </div>

          <button
            type="button"
            className={"offer-card-radio" + (selected ? " offer-card-radio--checked" : "")}
            onClick={(e) => {
              e.stopPropagation();
              onToggle();
            }}
            aria-pressed={selected}
          >
            <span className="offer-card-radio-circle" />
          </button>
        </div>

        <div className="offer-card-main">
          <span className="offer-card-topup">
            <img src={topUpAvailable ? checkIcon : crossIcon} alt="" className="offer-card-topup-icon" />
            <span className="offer-card-topup-text">
              {topUpAvailable ? t("offers.topUpAvailable") : t("offers.topUpNotAvailable")}
            </span>
          </span>

          <span className="offer-card-days">
            <img src={calendarIcon} alt="" className="offer-card-days-icon" />
            {duration} {duration === 1 ? t("common.day") : t("common.days")}
          </span>
        </div>

        <div className="offer-card-price">
          <span className="offer-card-price-value">
            {price.toFixed(2)} {currency}
          </span>
        </div>
      </div>
    </div>
  );
};

export default OfferCard;
